import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    setToken,
    removeToken,
    setName,
    removeName
} from '@/require/auth'
import $ from 'jquery'

Vue.use(VueRouter)

const Index = () =>
    import('@/views/Home')
const Politics = () =>
    import('@/views/Database/politics')
const GIS = () =>
    import('@/views/Database/politics_GIS')
const Table = () =>
    import('@/views/Database/politics_table')
const CGIT = () =>
    import('@/views/Database/cgit')
const Dbusiness = () =>
    import('@/views/Database/dbusiness')
const DbusinessF = () =>
    import('@/views/Database/dbusiness_first')
const DbusinessS = () =>
    import('@/views/Database/dbusiness_second')
const Trade = () =>
    import('@/views/Database/trade')
const DrawTable = () =>
    import('@/components/Table')

const MSR = () =>
    import('@/views/Exponent/msr')
const ZDO = () =>
    import('@/views/Exponent/zdo')
const Global = () =>
    import('@/views/Exponent/global')
const OBOR = () =>
    import('@/views/Exponent/obor')

const Expintro = () =>
    import('@/components/ExpIntro')
const List = () =>
    import('@/views/Literature/list')
const Channel = () =>
    import('@/views/Literature/channel')
const List2 = () =>
    import('@/views/Literature/list2')
const Channel2 = () =>
    import('@/views/Literature/channel2')

const Introduce = () =>
    import('@/components/Introduce')
const Power = () =>
    import('@/components/Power')
// const Guide = () => import('@/components/Guide')
const PowerIndicators = () =>
    import('@/components/PowerIndicators')
const Pillar = () => import("@/views/Database/Pillar/index.vue")
const Economy = () => import("@/views/Database/Pillar/economy.vue")
// const PillarPage = () => import("@/views/Database/Pillar/PillarPage.vue")

const routes = [{
    path: '/',
    component: Index,
    name: 'home'
},
{
    path: '/db/politics',
    component: Politics,
    children: [{
        path: '/db/politics/GIS',
        name: 'GIS',
        component: GIS
    },
    {
        path: '/db/politics/Table',
        name: 'Table',
        component: Table
    }
    ]
},
{
    path: '/db/cgit',
    name: 'cgit',
    component: CGIT
},
{
    path: '/db/dbusiness',
    name: 'dbusiness',
    component: Dbusiness,
    children: [{
        path: '/db/DbusinessF',
        name: 'DbusinessF',
        component: DbusinessF
    },
    {
        path: '/db/DbusinessS',
        name: 'DbusinessS',
        component: DbusinessS
    },
    {
        path: '/db/Pillar',
        name: 'Pillar',
        component: Pillar,
    },
    {
        path: '/db/economy',
        name: 'economy',
        component: Economy,
    }]
},
{
    path: '/db/trade',
    name: 'trade',
    component: Trade
},
{
    path: '/exp/msr',
    name: 'msr',
    component: MSR,
    children: [{
        path: '/exp/msr/zdo',
        name: 'zdo',
        component: ZDO
    },
    {
        path: '/exp/msr/global',
        name: 'global',
        component: Global
    }
    ]
},
{
    path: '/exp/obor',
    name: 'obor',
    component: OBOR
},
{
    path: '/exp/expintro',
    name: 'expintro',
    component: Expintro
},
{
    path: '/lit/list',
    name: 'list',
    component: List,
    redirect: '/lit/channel',
    children: [{
        path: '/lit/channel',
        name: 'channel',
        component: Channel
    }]
},
{
    path: '/lit/list2',
    name: 'list2',
    component: List2,
    redirect: '/lit/channel2',
    children: [{
        path: '/lit/channel2',
        name: 'channel2',
        component: Channel2
    }]
},
{
    path: '/intro',
    component: Introduce,
    name: 'introduce'
},
{
    path: '/databasetable',
    component: DrawTable,
    name: 'databasetable'
},
{
    path: '/power',
    component: Power,
    name: 'power'
},
// {
//   path: '/guide',
//   component: Guide,
//   name: 'guide'
// },
{
    path: '/powerIndicators',
    component: PowerIndicators,
    name: 'powerIndicators'
}
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    // next()
    // return
    // 查找是否访问旧版的记录
    if (localStorage.getItem("isOldVersion")) {
        window.location.href = "http://ydyl2.drcnet.com.cn/www/ydyl/";
        return
    }
    // 埋点系统 start
    try {
        if (LogCollection) {
            LogCollection.end()
        }
    } catch (e) {
        // LogCollection.init()
    }
    $.ajax({
        url: 'http://user.drcnet.com.cn/userapi/loginController/initLoginP',
        // url: 'https://user.drcnet.com.cn/userapi/loginController/initLogin?flag=init',
        type: 'get',
        responseType: 'application/json',
        dataType: 'jsonp',
        jsonpCallback: 'showData',
        xhrFields: {
            withCredentials: true
        },
        // crossDomain: true,
        // async: false,
        success: function (data) {
            if (data.Logined === 0) {
                removeName()
                removeToken()
                if (to.path === '/' || to.path === '/guide' || to.path === '/intro') {
                    // console.log('无权限')
                    next()
                } else if (to.path === '/lit/channel' || to.path === '/lit/channel2') {
                    // console.log('无权限')
                    next()
                } else {
                    // console.log('有权限')
                    let skipUrl = window.location.origin + '/#' + to.fullPath
                    let url = 'http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx'
                    let loginUrl = url + '?gourl=' + skipUrl.replace('?', '~~').replace('&', '^')
                    window.location.href = loginUrl
                }
            } else {
                setName(data.UserName)
                setToken(data.UserToken)
                next()
            }
        }
    })
})

router.afterEach(() => {
    try {
        if (LogCollection) {
            LogCollection.init()
        }
    } catch (e) {
        console.log(e)
    }
})

export default router